export const SELECTOR_DESIGN_CODE = (code) => (state) => {
  return state.designs.designs[code];
};
